import { Core } from "@faire/design-tokens";
// eslint-disable-next-line @faire/enforce-internal-folder-encapsulation
import { IBrandSubtitleProps } from "@faire/retailer-visitor-shared/src/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageHeader/__internal__/SearchPageBrandSearch/BrandSearch/BrandSearchSubtitle";
import { Star } from "@faire/web--source/slate/icons/foundation/Star";
import { Row } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";

export const BrandRating: React.FC<{
  brand: IBrandSubtitleProps | undefined;
}> = ({ brand }) => {
  if (brand?.avg_brand_review_rating) {
    return (
      <Row align="center">
        <Typography variant="paragraphSansRegular">
          <Star fontSize="14px" fill={Core.icon.default} />
        </Typography>
        <Spacer size="1/2x" />
        <Typography variant="paragraphSansRegular">
          {brand?.avg_brand_review_rating}
        </Typography>
      </Row>
    );
  }
  return null;
};
